(function(){
  var form = document.querySelector('form[action="/cart/add"]');
  if (!form) {
    console.error('Unable to find add to cart form element for customizer');
    return;
  }
  var button = form.querySelector('button[type="submit"]');
  if (!button) {
    console.error('Unable to find add to cart form for customizer');
    return;
  }
  // Keep the theme's label element: variant changes update it by ID.
  var label = button.querySelector('[id^="AddToCartText-"]') || button.querySelector('span') || button;
  label.textContent = button.disabled ? 'Out of stock' : 'Customize';
  button.classList.add('foxbox-customize-button');
  button.addEventListener("click", function (e) {
    if (button.disabled) {
      e.preventDefault();
      return;
    }
    // [name="id"] covers BOTH a <select name="id"> (legacy themes) and the hidden
    // <input name="id"> that Dawn / Online Store 2.0 themes use. Querying only a
    // <select> threw a TypeError on modern themes, dead-ending the relabelled
    // button (it neither customized nor added to cart).
    var variantEl = form.querySelector('[name="id"]');
    var variantId = variantEl && variantEl.value;
    if (!variantId) {
      // Don't preventDefault when we can't route to the customizer — let the
      // native add-to-cart proceed rather than leaving the button doing nothing.
      console.error('Unable to find variant ID to customize in cart form');
      return;
    }
    e.preventDefault();
    window.location.href = "/apps/foxbox-editor/" + variantId;
  });
})();
